import React from 'react';
import styles from '../accountDetails.module.css';
import { tWithKeyAttr as t } from "../../../../i18nHelper";

interface LoginHistoryTabProps {
}

export const LoginHistoryTab: React.FC<LoginHistoryTabProps> = () => {
  return (
    <div className={styles.loginHistoryContent}>
      <h2>{t("LOGIN_HISTORY")}</h2>
    </div>
  );
};
